<smrts-page [tabTitle]="title">

  <div header class="header inline-element">
    <h1 #overflow="smrtsOverflowDetector" smrtsOverflowDetector class="primary-color page-title"
      [matTooltip]="title" [matTooltipDisabled]="!overflow.truncado">{{ title }}</h1>

    <a [routerLink]="voltarLink" mat-icon-button matTooltip="Voltar" class="accent-color">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
    <button *hasPermission="permissaoExportarConciliacao" mat-raised-button class="btn-exportar" (click)="exportarConciliacaoClick()">Exportar Conciliação</button>
    <button mat-raised-button (click)="salvar()" [disabled]="isHistorico" [disableNoPermission]="permissaoEditarConciliacao">Salvar</button>
  </div>

  <div class="content">
    <p-splitter layout="vertical" class="splitter" [style]="{ height: '100%' }" [panelSizes]="[35, 65]" [minSizes]="[15, 30]">

      <ng-template #panel>
        <app-card-busca></app-card-busca>
      </ng-template>

      <ng-template #panel>
        <p-splitter class="splitter" [style]="{ height: '100%' }" [panelSizes]="[50, 50]" [minSizes]="[25, 25]">

          <ng-template #panel>
            <app-card-lancamentos [tipoCard]="1" [conciliacaoId]="dadosConciliacao.conciliacaoId"></app-card-lancamentos>
          </ng-template>

          <ng-template #panel>
            <app-card-lancamentos [tipoCard]="0" [conciliacaoId]="dadosConciliacao.conciliacaoId"></app-card-lancamentos>
          </ng-template>

        </p-splitter>
      </ng-template>

    </p-splitter>
  </div>

</smrts-page>